import { getGlobalSoundEnabled } from './soundPreferences';

function isSoundEnabled() {
  return getGlobalSoundEnabled();
}

function clickAlert() {
  if (typeof window === 'undefined') return;
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return;

  try {
    const ctx = new AudioCtx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.type = 'square';
    osc.frequency.value = 1300;
    gain.gain.value = 0.00001;

    osc.connect(gain);
    gain.connect(ctx.destination);

    const now = ctx.currentTime;
    gain.gain.exponentialRampToValueAtTime(0.1, now + 0.004);
    gain.gain.exponentialRampToValueAtTime(0.00001, now + 0.05);

    osc.start(now);
    osc.stop(now + 0.06);

    window.setTimeout(() => {
      try {
        ctx.close();
      } catch {
        // ignore close failures
      }
    }, 350);
  } catch {
    // Ignore audio failures quietly
  }
}

export function notifyPlayerTurn(_gameName) {
  if (!isSoundEnabled()) return;
  clickAlert();
}
